module.exports = __webpack_public_path__ + "img/inventory.bbe395c2.png";